module.exports = __webpack_public_path__ + "static/img/16.715cbd3b.png";